module.exports = __webpack_public_path__ + "assets/img/icon_action_show.b8eda526.svg";